<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="登录账号：" prop="loginName">
            <el-input style="width: 400px;" v-model="ruleForm.loginName" placeholder="请输入登录账号"></el-input>
          </el-form-item>
          <el-form-item v-if="dataId == ''" label="登录密码：" prop="loginPassword">
            <el-input style="width: 400px;" v-model="ruleForm.loginPassword" placeholder="请输入登录密码"></el-input>
          </el-form-item>
          <el-form-item label="门店名称：" prop="shopName">
            <el-input style="width: 400px;" v-model="ruleForm.shopName" placeholder="请输入门店名称"></el-input>
          </el-form-item>
          <el-form-item label="门店logo：" prop="shopLogo">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-remove="delImgBtn"
              :on-success="bannerImgBtn">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="营业时间：" prop="timeRange">
            <el-time-picker
              style="width: 400px;"
              is-range
              v-model="ruleForm.timeRange"
              value-format="HH:mm:ss"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-time-picker>
          </el-form-item>
          <el-form-item label="联系人：" prop="linkName">
            <el-input style="width: 400px;" v-model="ruleForm.linkName" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="linkPhone">
            <el-input style="width: 400px;" v-model="ruleForm.linkPhone" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input style="width: 400px;" v-model="ruleForm.address" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="经度：" prop="latitude">
            <el-input style="width: 400px;" v-model="ruleForm.latitude" placeholder="请输入经度"></el-input>
            <a class="color-theme" style="display: inline-block;" href="https://lbs.qq.com/tool/getpoint/index.html" target="_blank">点击获取</a>
          </el-form-item>
          <el-form-item label="纬度：" prop="longitude">
            <el-input style="width: 400px;" v-model="ruleForm.longitude" placeholder="请输入纬度"></el-input>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveShopInfo, updateShopInfo, fetchShopInfoDetailById } from '@/api/shop'
export default {
  name: 'ShopAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      fullscreenLoading: false,
      fileList: [],
      ruleForm: {
        loginName:'',
        loginPassword:'',
        shopName:'',
        shopLogo:'',
        startBusinessTime:'',
        endBusinessTime:'',
        timeRange: ['08:00:00', '19:00:00'],
        linkName:'',
        linkPhone:'',
        address:'',
        latitude:'',
        longitude:'',
        status: false
      },
      rules: {
        loginName: [
          { required: true, message: '请输入登录账号', trigger: 'blur' }
        ],
        shopName: [
          { required: true, message: '请输入门店名称', trigger: 'blur' }
        ],
        shopLogo: [
          { required: true, message: '请上传门店logo', trigger: 'blur' }
        ],
        timeRange: [
          { required: true, message: '请选择营业时间', trigger: 'blur' }
        ],
        linkName: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        linkPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        latitude: [
          { required: true, message: '请输入经度', trigger: 'blur' }
        ],
        longitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if (this.$route.query.dataId !== '') {
      let that = this
      fetchShopInfoDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.loginName = data.loginName
          that.ruleForm.shopName = data.shopName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.linkName = data.linkName
          that.ruleForm.linkPhone = data.linkPhone
          that.ruleForm.shopLogo = data.shopLogo
          that.fileList.push({url: data.shopLogo})
          if(data.startBusinessTime != null){
            that.ruleForm.timeRange = [data.startBusinessTime,data.endBusinessTime]
          }
          that.ruleForm.address = data.address
          that.ruleForm.latitude = data.latitude
          that.ruleForm.longitude = data.longitude
        }
      });
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    bannerImgBtn (file) {
      this.ruleForm.shopLogo = file.data.fileUrl
    },
    /* 删除上传的图片 */
    delImgBtn(file,fileList){
      var imgUrl = '';
      fileList.forEach(function(item){
        imgUrl = item.url;
      });
      this.ruleForm.shopLogo = imgUrl;
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let loginName = that.ruleForm.loginName
      let loginPassword = that.ruleForm.loginPassword
      let shopName = that.ruleForm.shopName
      let shopLogo = that.ruleForm.shopLogo
      let linkName = that.ruleForm.linkName
      let linkPhone = that.ruleForm.linkPhone
      let address = that.ruleForm.address
      let latitude = that.ruleForm.latitude
      let longitude = that.ruleForm.longitude
      let status = that.ruleForm.status ? 1 : 0
      let startTime = ''
      let endTime = ''
      if (that.ruleForm.timeRange !== null) {
        startTime = that.ruleForm.timeRange[0]
        endTime = that.ruleForm.timeRange[1]
      }
      if (loginName === '') {
        this.$message.error('请输入登录账号')
        return false
      }
      if (shopName === '') {
        this.$message.error('请输入门店名称')
        return false
      }
      if (shopLogo === '') {
        this.$message.error('请上传门店logo')
        return false
      }
      if (startTime === '') {
        this.$message.error('请选择营业时间')
        return false
      }
      if (linkName === '') {
        this.$message.error('请输入联系人')
        return false
      }
      if (linkPhone === '') {
        this.$message.error('请输入联系电话')
        return false
      }
      if (address === '') {
        this.$message.error('请输入详细地址')
        return false
      }
      if (latitude === '') {
        this.$message.error('请输入经度')
        return false
      }
      if (longitude === '') {
        this.$message.error('请输入纬度')
        return false
      }
      let passData = {
        loginName: loginName, shopName: shopName, shopLogo: shopLogo, startBusinessTime: startTime, endBusinessTime: endTime, linkName: linkName, linkPhone:linkPhone,address:address,latitude:latitude, longitude:longitude, status: status
      }
      that.fullscreenLoading = true
      if (dataId !== '') {
        passData.id = dataId;
        updateShopInfo(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        passData.loginPassword = loginPassword;
        saveShopInfo(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      that.fullscreenLoading = false
      if (res.errorCode === '0000') {
        that.$router.go(-1)
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {}
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/shop/Add.vue